// Core React Imports
import React from "react";

// Local Imports
import { AlertDialogBackground, DivColumn, ParagraphText } from "../../../styles/SharedStyles";
import ConstantsTexts from "../../../constants/ConstantsTexts";
import ConstantsParams from "../../../constants/ConstantsParams";

// CSS/Stylesheets
import "./WidgetAlertDialogEdit.css";

const WidgetAlertDialogEdit = ({ onCancel, onApprove, messageText, approveText, cancelText, actionType }) => {
  // Determine background color based on action type
  const getBackgroundColor = () => {
    if (actionType === ConstantsParams.ActionTypes.DELETE || actionType === ConstantsParams.ActionTypes.DELETE_VERSION) {
      return "#EB6366";
    }
    return "#5a81fa"; // Default blue color
  };

  return (
    <AlertDialogBackground>
      <DivColumn className="alert-dialog-overlay-edit" style={{ background: getBackgroundColor() }}>
        <DivColumn className="alert-dialog-overlay-2-edit">
          <div className="alert-dialog-overlay-3-edit">
            <ParagraphText className="alert-dialog-overlay-text-edit" style={{ textAlign: "center" }}>
              {ConstantsTexts.CODE_33}
            </ParagraphText>
          </div>
          <ParagraphText className="alert-dialog-overlay-text-2-edit" style={{ textAlign: "center" }}>
            {messageText}
          </ParagraphText>
        </DivColumn>
        <div className="alert-dialog-overlay-4-edit">
          <DivColumn className="alert-dialog-overlay-5-edit" style={{ height: "5rem" }} onClick={onApprove}>
            <ParagraphText className="alert-dialog-overlay-text-3-edit" style={{ textAlign: "center" }}>
              {approveText}
            </ParagraphText>
          </DivColumn>
          <DivColumn className="alert-dialog-overlay-6-edit" style={{ height: "5rem" }} onClick={onCancel}>
            <ParagraphText className="alert-dialog-overlay-text-3-edit" style={{ textAlign: "center" }}>
              {cancelText}
            </ParagraphText>
          </DivColumn>
        </div>
      </DivColumn>
    </AlertDialogBackground>
  );
};

export default WidgetAlertDialogEdit;
